import { NgModule } from '@angular/core';
import { KendoDraggableDirective } from './common/draggable';
import { CommonModule } from '@angular/common';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
/**
 * @hidden
 */
/**
 * @hidden
 */
var DraggableModule = /** @class */ (function () {
    function DraggableModule() {
    }
    DraggableModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [KendoDraggableDirective],
                    exports: [KendoDraggableDirective],
                    imports: [CommonModule],
                    providers: [
                        { provide: IntlService, useClass: CldrIntlService }
                    ]
                },] },
    ];
    /** @nocollapse */
    DraggableModule.ctorParameters = function () { return []; };
    return DraggableModule;
}());
export { DraggableModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-inputs/dist/es/draggable.module.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/draggable.module.js
// module chunks = vendor